module.exports = __webpack_public_path__ + "static/media/1.e1c30d1d.jpg";